import { Select, SelectProps } from '@mantine/core';

import { useGetCompanyRoleQuery } from '@api/companyRole.api';
import { uniqueByName } from '@utils/strings';

export default function CompanyRoleSelector(props: SelectProps) {
  const { data = [], isLoading } = useGetCompanyRoleQuery();
  const selectData = uniqueByName(data).map((companyRole) => ({
    label: companyRole.name,
    value: companyRole.name,
  }));

  return (
    <Select
      label="Ruolo"
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : 'Seleziona il tuo ruolo aziendale'
      }
      data={selectData}
      disabled={isLoading}
      {...props}
    />
  );
}
